module.exports = __webpack_public_path__ + "img/box-cliAdmin.8557d17f.png";